import React from 'react';

import './custom-arrow-style.scss';

import ChevronRightIcon from '@src/componentsNew/Icons/Icons/ChevronRightIcon';
import ChevronLeftIcon from '@src/componentsNew/Icons/Icons/ChevronLeftIcon';

interface IProps {
  onClick?: any;
  direction: 'next' | 'prev';
}

const CustomArrow = ({ onClick, direction }: IProps) => {
  return (
    <div className={`custom-arrow-wrapper ${direction}`} onClick={onClick}>
      {direction === 'next' ? (
        <ChevronRightIcon cName="custom-right-arrow" strokeColor="#FFFFFF" />
      ) : (
        <ChevronLeftIcon cName="custom-left-arrow" strokeColor="#FFFFFF" />
      )}
    </div>
  );
};

export default CustomArrow;
